import React from "react";
import CardHeader from "@mui/material/CardHeader";
import {
  Card,
  CardActions,
  CardContent,
  LinearProgress,
  Typography,
} from "@mui/material";
import Stack from "@mui/material/Stack";
import Grid from "@mui/material/Grid";
import TrendingDownSharpIcon from "@mui/icons-material/TrendingDownSharp";
import Button from "@mui/material/Button";
import AddIcon from "@mui/icons-material/Add";
import { useTranslation } from "react-i18next";

const DashboardCard = ({title, text, date, primaryButtonText, secondaryButtonText, actionPrimaryButton, actionSecondaryButton}) => {
  const { t } = useTranslation();
  return (
    <Card>
      <CardHeader title={title} />
      <CardContent sx={{ pt: 2 }}>
        <Stack direction={"row"} spacing={3}>
          <Grid item xs={6}>
            <Typography variant={"h2"}>
              {text}
            </Typography>
            <Typography variant={"body1"} sx={{ mb: 3 }}>
              Data de publicação: {date}
            </Typography>
            <Stack direction={"row"} spacing={1}>
              <Button variant={"contained"} color={"secondary"} onClick={actionPrimaryButton}>
                {primaryButtonText}
              </Button>
              <Button variant={"contained"} color={"inherit"} disableElevation onClick={actionSecondaryButton}>
                {secondaryButtonText}
              </Button>
            </Stack>
          </Grid>
        </Stack>
      </CardContent>
    </Card>
  );
};

export default DashboardCard;
